import { POSTS } from "../lib/constants/actions";
export const post = (state = {}, action) => {
    switch (action.type) {
        case POSTS.GET_REPORTED_POSTS_SUCCESS:
            return { ...state, reportPost: action.payload }
        case POSTS.GET_SEARCHES_SUCCESS:
            return { ...state, searches: action.payload }
        case POSTS.GET_FAVOURITES_SUCCESS:
            return { ...state, favourites: action.payload }
        case POSTS.VIEWED_BY_SUCCESS:
            return { ...state, viewedBy: action.payload }
        case POSTS.REPORTED_BY_SUCCESS:
            return { ...state, reportedBy: action.payload }
        case POSTS.POST_DETAILS_SUCCESS:
            return { ...state, postdetails: action.payload }
            case POSTS.DELETE_POST_SUCCESS:
            return { ...state, postDeleted: action.payload }
        default:
            return state;
    }
};




